/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitCapacitor = createReactComponent("outline", "circuit-capacitor", "IconCircuitCapacitor", [["path", { "d": "M22 12h-8", "key": "svg-0" }], ["path", { "d": "M2 12h8", "key": "svg-1" }], ["path", { "d": "M10 7v10", "key": "svg-2" }], ["path", { "d": "M14 7v10", "key": "svg-3" }]]);

export { IconCircuitCapacitor as default };
//# sourceMappingURL=IconCircuitCapacitor.mjs.map
